import { getLink } from '../../../utils/utils';
import author from './author';

const content = {
  esp: (
    `
    







 


    <div class="poem">
		<p class="mb-3 text-center">
			<i>
				Festo en Zooparko
			</i>
		</p>
		<p class="poem-block mb-5">
            Trata-tam, trata-tam<br/>
            Marŝas la hipopotam’;<br/>
            Kuru-ru, Kuru-ru,<br/>
            Jen aperas kanguru’!<br/>
            Truru-truru sonas kanto<br/>
            De longnaza elefanto.<br/>
            Du simioj – Ĉu kaj Ĉa –<br/>
            Salte dancas ĉa-ĉa-ĉa!<br/>
            Kia bruo! Kia bruo!<br/>
            Supren levas bekon gruo.<br/>
            Ĉu okazis incendio?<br/>
            Brulas kie? Brulas kio?<br/>
            Diras muso Miki-Maŭso:<br/>
            Ne nervumu min sen kaŭzo!<br/>
            Gajas ĉiu parka besto<br/>
            Pro leona edziĝfesto!
		</p>



        <p class="mb-3 text-center">
			<i>
				Ni festenas Novan Jaron!
			</i>
		</p>
		
		<p class="poem-block mb-3">
            En la val’ abio staris;<br/>
            Olda estis ĝi kaj knaris.<br/>
            Kun hakilo venis hom’…<br/>
            Jen abio en la dom’<br/>
            Staras dum la granda festo:<br/>
            Ĝin adoras ĉiu besto<br/>
            Kaj feliĉas infanar’:<br/>
            Venis al ni Nova Jar’! 
		</p>
		
		<p class="poem-block mb-3">
            Naskiĝis abieto jen<br/>
            En verda densarbar,<br/>
            Ĝi estis juna, bela en<br/>
            La rond’ de l’ amikar’.
		</p>
		
		<p class="poem-block mb-3">
            El la neĝ’ post longa rulo<br/>
            Rezultiĝis granda bulo. <br/>
            Ni enmetis en ĉi-kapon <br/>
            Kiel nazo – grandan rapon,<br/>
            Du karberojn – por okuloj,<br/>
            Poste-<br/>
            Vosto,<br/>
            Du oreloj – <br/>
            La leporo iĝis bela!
		</p>
		
		<p class="poem-block mb-3">
            Sub abio leporetoj<br/>
            Dancas en arbar’,<br/>
            Ili ĉiuj estas pretaj<br/>
            Por la Nova Jar’!<br/>
            Venu, granda festo!<br/>
            Ĝoju, ĉiu besto!
		</p>
		
		<p class="poem-block mb-5">
            Jen venis mi al via rond’ –<br/>
            Plej bona besto en la mond’!<br/>
            Sub la abio verda, brila<br/>
            Festenu ĉiuj ni jubile! 
		</p>


        
		<p class="mb-3 text-center">* * *</p>
		<p class="poem-block mb-5">
            Tanjo apud maro ploras:<br/>
            Pilko ruĝa tie dronas.<br/>
            Cit, ne ploru, Tanjo mia,<br/>
            Ne ekdronos pilko via!
		</p>


        
		<p class="mb-3 text-center">* * *</p>
		<p class="poem-block mb-5">
            Oni urson teren ĵetis,<br/>
            Oni urson krude tretis.<br/>
            Sed mi lasos lin neniam:<br/>
            Li amata estas mia!
		</p>


        
		<p class="mb-3 text-center">* * *</p>
		<p class="poem-block mb-5">
            Leporeton lasis Ola.<br/>
            Sur la benk’ li restis sola,<br/>
            Ne forkuris dum la pluv’ –<br/>
            Malsekigis lin diluv’. 
		</p>



        <p class="mb-3 text-center">
			<b>
				Enigmoj
			</b>
		</p>
        
		<p class="poem-block mb-5">
            Purpura kresto,<br/>
            Oraj spronoj,<br/>
            En  plumoj buntas<br/>
            Kolortonoj.<br/>
            Ĝi batalemas,<br/>
            Arde pikas,<br/>
            Post ĉiu venko<br/>
            Kokerikas.
			<i style="transform:rotate(180deg)">
                Koko
			</i>
		</p>


		<p class="poem-block mb-5">
            Estas mi malgranda besto<br/>
            En ruĝ-flava varma vesto.<br/>
            Kredu, mi ne estas ruza;<br/>
            Simple gaja kaj amuza.<br/>
			<i style="transform:rotate(180deg)">
                Vulpo
			</i>
		</p>
	</div>
    `
  )
}

const itemName = {
  esp: 'Al konata pentristo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}


export default item;